export const actionConst = {
  VISIBLE_DOCUMENT_DRAWER: 'VISIBLE_DOCUMENT_DRAWER',
  OPEN_NEW_DOCUMENT_MODAL: 'OPEN_NEW_DOCUMENT_MODAL',
  UPDATE_NEW_DOCUMENT_MODAL: 'UPDATE_NEW_DOCUMENT_MODAL',
  CLOSE_NEW_DOCUMENT_MODAL: 'CLOSE_NEW_DOCUMENT_MODAL',
  FETCH_DOCTYPE_REF: 'FETCH_DOCTYPE_REF',
  FETCH_ORDTYPE_REF: 'FETCH_ORDTYPE_REF',
  FETCH_OSS_TYPE_REF: 'FETCH_OSS_TYPE_REF',
  FETCH_CONTRACT_TYPE_REF: 'FETCH_CONTRACT_TYPE_REF',
  FETCH_EXECUTER_REF: 'FETCH_DOC_EXECUTER_REF',
  FETCH_RESPONSIBLE_WORKERS: 'FETCH_RESPONSIBLE_WORKERS',
  POST_DOCUMENT: 'POST_DOCUMENT',
  DELETE_DOCUMENT: 'DELETE_DOCUMENT',
  RESET_POSTED_DOCUMENT: 'RESET_POSTED_DOCUMENT',
  FETCH_ADDR_STREET_REF: 'FETCH_DOC_ADDR_STREET_REF',
  APPLY_ADDR_STREET: 'APPLY_DOC_ADDR_STREET',
  FETCH_ADDR_BUILDING_REF: 'FETCH_DOC_ADDR_BUILDING_REF',
  FETCH_ADDR_FLAT_REF: 'FETCH_DOC_ADDR_FLAT_REF',
  SET_ADDR_BUILDING_VALUE: 'SET_DOC_ADDR_BUILDING_VALUE',
  SET_ADDR_FLAT_VALUE: 'SET_DOC_ADDR_FLAT_VALUE',
  FETCH_SERVICE_COMPANIES_LIST: 'FETCH_SERVICE_COMPANIES_LIST',
  FETCH_DOCUMENT_VISIBILITY_LIST: 'FETCH_DOCUMENT_VISIBILITY_LIST',
  OPEN_EDIT_DOCUMENT: 'OPEN_EDIT_DOCUMENT',
  OPEN_CREATE_DOCUMENT: 'OPEN_CREATE_DOCUMENT',
  UPDATE_FORM_VALUES: 'UPDATE_FORM_VALUES',
  CLOSE_DOCUMENT_DRAWER: 'CLOSE_DOCUMENT_DRAWER',
  SET_DOCUMENTS_CHOSEN_FILTER: 'SET_DOCUMENTS_CHOSEN_FILTER',
  OPEN_DOCUMENT_CREATE_BY_RELATED: 'OPEN_DOCUMENT_CREATE_BY_RELATED',
};
